import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CommunityUpdatesCard = ({ updates }) => {
  const getUpdateIcon = (type) => {
    const icons = {
      'announcement': 'Megaphone',
      'success': 'CheckCircle2',
      'milestone': 'Trophy',
      'news': 'Newspaper'
    };
    return icons?.[type] || 'Info';
  };

  const getUpdateColor = (type) => {
    const colors = {
      'announcement': 'text-blue-600 bg-blue-50 border-blue-200',
      'success': 'text-green-600 bg-green-50 border-green-200',
      'milestone': 'text-amber-600 bg-amber-50 border-amber-200',
      'news': 'text-purple-600 bg-purple-50 border-purple-200'
    };
    return colors?.[type] || 'text-gray-600 bg-gray-50 border-gray-200';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border">
      <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Bell" size={24} className="text-secondary" />
        Community Updates
      </h2>
      <div className="space-y-4 max-h-96 overflow-y-auto custom-scrollbar">
        {updates?.map((update) => (
          <div
            key={update?.id}
            className={`p-4 rounded-lg border ${getUpdateColor(update?.type)} transition-all hover:shadow-md`}
          >
            <div className="flex gap-3">
              <div className="flex-shrink-0">
                <Icon name={getUpdateIcon(update?.type)} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="font-semibold text-foreground line-clamp-2">
                    {update?.title}
                  </h3>
                  <span className="flex-shrink-0 text-xs text-muted-foreground">
                    {formatDate(update?.date)}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-3 line-clamp-3">
                  {update?.description}
                </p>
                {update?.image && (
                  <div className="mb-3 rounded-lg overflow-hidden h-32 bg-muted">
                    <Image
                      src={update?.image}
                      alt={update?.imageAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  {update?.likes && (
                    <span className="flex items-center gap-1">
                      <Icon name="Heart" size={14} />
                      {update?.likes}
                    </span>
                  )}
                  {update?.comments && (
                    <span className="flex items-center gap-1">
                      <Icon name="MessageCircle" size={14} />
                      {update?.comments}
                    </span>
                  )}
                  {update?.shares && (
                    <span className="flex items-center gap-1">
                      <Icon name="Share2" size={14} />
                      {update?.shares}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunityUpdatesCard;